import { mapFormFieldsJSON } from '@/store/helpers/formHelper.js'

export default {
  SET_CALCULATOR_COMMUNITY (state, community) {
    state.communityId = community
    state.calculatorType = null
    state.formData = {}
    state.estimate = {}
  },
  SET_CALCULATOR_TYPE (state, calculatorType) {
    state.calculatorType = calculatorType
    state.formData = {}
    state.estimate = {}
  },
  SET_CALCULATOR_FORM_FIELDS (state, applicationJSON) {
    const newState = mapFormFieldsJSON(applicationJSON)
    state.formData = newState
  },
  SET_FORMFIELD_VALUE (state, { tab, field, value }) {
    state.formData[tab][field] = value
  },
  SET_ESTIMATE (state, estimate) {
    state.estimate = estimate
  }
}
